import { render, staticRenderFns } from "./detalleReconocimientoFacial.vue?vue&type=template&id=40ea266a"
import script from "./detalleReconocimientoFacial.vue?vue&type=script&lang=js"
export * from "./detalleReconocimientoFacial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports